import { DtoBase } from "../../DtoBase";
import { HashSet, Dictionary, Iterable, ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization";
import { AccountType, DirectoryUserDto } from "UvExplorerServer.Dtos.TS/Auth";


export class DirectoryUsersDto extends DtoBase {

	public AccountType: AccountType;
	public DomainName: string;
	public Users: HashSet<DirectoryUserDto>;
	// Not serialized
	private EphemeralIdIndex: Dictionary<string, DirectoryUserDto>;
	private PermanentIdIndex: Dictionary<string, DirectoryUserDto>;

	constructor() {
		super();

		this.AccountType = AccountType.Native;
		this.DomainName = "";
		this.Users = new HashSet<DirectoryUserDto>();
		this.EphemeralIdIndex = new Dictionary<string, DirectoryUserDto>();
		this.PermanentIdIndex = new Dictionary<string, DirectoryUserDto>();
	}

	public Clear(): void {
		this.AccountType = AccountType.Native;
		this.DomainName = "";
		this.Users.Clear();
		this.EphemeralIdIndex.Clear();
		this.PermanentIdIndex.Clear();
	}

	public get HasDomainName(): boolean {
		return !!this.DomainName;
	}

	public get HasUsers(): boolean {
		return (!!this.Users && this.Users.Count > 0);
	}

	public Add(user: DirectoryUserDto): void {

		console.assert(!this.Users.Contains(user));
		console.assert(!user.HasEphemeralId || !this.EphemeralIdIndex.ContainsKey(user.EphemeralId));
		console.assert(!user.HasPermanentId || !this.PermanentIdIndex.ContainsKey(user.PermanentId));

		this.Users.Add(user);

		if (user.HasEphemeralId)
			this.EphemeralIdIndex.Add(user.EphemeralId, user);

		if (user.HasPermanentId)
			this.PermanentIdIndex.Add(user.PermanentId, user);
	}

	public AddRange(users: Iterable<DirectoryUserDto>): void {
		users.ForEach((u: DirectoryUserDto) => {
			this.Add(u);
		});
	}

	public Remove(user: DirectoryUserDto): boolean {
		if (this.Users.Contains(user)) {

			this.Users.Remove(user);

			if (user.HasEphemeralId) {
				this.EphemeralIdIndex.Remove(user.EphemeralId);
			}

			if (user.HasPermanentId) {
				this.PermanentIdIndex.Remove(user.PermanentId);
			}

			return true;
		}
		else {
			return false;
		}
	}

	public FindUserById(id: string): DirectoryUserDto {

		if (this.EphemeralIdIndex.ContainsKey(id)) {
			return this.EphemeralIdIndex.Item(id);
		}

		if (this.PermanentIdIndex.ContainsKey(id)) {
			return this.PermanentIdIndex.Item(id);
		}

		return null;
	}

	public Write(obj: any, context: any): void {
		obj.directory_users = {};
		obj = obj.directory_users;

		super.Write(obj, context);

		obj.account_type = AccountType[this.AccountType];

		if (this.HasDomainName) {
			obj.domain_name = this.DomainName;
		}

		if (this.HasUsers) {
			obj.users = [];
			ObjSerUtils.WriteObjSerCollection(obj.users, this.Users, {});
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.directory_users)
			throw new Error();
		obj = obj.directory_users;

		super.Read(obj, context);

		if (obj.account_type !== undefined) {
			this.AccountType = AccountType[<string>obj.account_type];
		}

		if (obj.domain_name !== undefined) {
			this.DomainName = obj.domain_name;
		}

		if (obj.users !== undefined) {
			this.Clear();
			obj.users.forEach((elem: any) => {
				let user = new DirectoryUserDto();
				user.Read(elem, context);
				this.Add(user);
			}, this);
		}
	}

}